import ActionIcon from 'components/BaseHelpers/ActionIcon';
import Link from 'components/BaseHelpers/Link';
import Text from 'components/BaseHelpers/Text';
import { OtherCollegeNavigationProps } from 'components/Core/CoreNavigationHeader/components/OtherCollegeNavigation';

import styles from '../OtherCollegeNavigation.module.scss';

type SubNavLinkProps = {
  options: OtherCollegeNavigationProps['dropdownMenu']['dropdownOptions'];
};

const SubNavLinks = ({ options }: SubNavLinkProps) => {
  return options.map((link, index) => {
    const { label, description } = link;
    return (
      <li key={index} className={styles.navItem}>
        <Link {...link} className={styles.link}>
          <div className={styles.copyWrapper}>
            <Text className={styles.label} tag="p" field={label} />
            {!!description && <Text className={styles.description} tag="p" field={description} />}
          </div>
          <ActionIcon className={styles.linkIcon} external size="large" />
        </Link>
      </li>
    );
  });
};

export default SubNavLinks;
